import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HiPlus, HiCollection } from "react-icons/hi";

const Button = () => {
  const [activeBtn, setActiveBtn] = useState("createBtn");

  return (
    <div className="mb-8">
      <h2 className="text-3xl font-bold text-text mb-6">Flashcards</h2>

      <div className="bg-gray-50 rounded-xl shadow-md">
        <div className="flex">
          <Link
            to="/"
            onClick={() => setActiveBtn("createBtn")}
            className={`flex-1 flex items-center justify-center space-x-2 py-4 px-6 
              transition-colors border-b-2 font-medium
              ${activeBtn === "createBtn"
                ? "text-primary border-primary"
                : "text-gray-600 border-transparent hover:text-primary/70"
              }`}
          >
            <HiPlus className="text-xl" />
            <span>Create New</span>
          </Link>

          <Link
            to="/myflashcard"
            onClick={() => setActiveBtn("flashBtn")}
            className={`flex-1 flex items-center justify-center space-x-2 py-4 px-6 
              transition-colors border-b-2 font-medium
              ${activeBtn === "flashBtn"
                ? "text-primary border-primary"
                : "text-gray-600 border-transparent hover:text-primary/70"
              }`}
          >
            <HiCollection className="text-xl" />
            <span>My Flashcards</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Button;
